/** Shallow equality for Canvas node `data.fields` — prevents no-op graph commits. */

export function canvasFieldsShallowEqual(
  before: Record<string, unknown> | undefined,
  after: Record<string, unknown>,
): boolean {
  const left = before || {}
  const rightKeys = Object.keys(after)
  const leftKeys = Object.keys(left)
  if (rightKeys.length !== leftKeys.length) return false
  for (const key of rightKeys) {
    if (left[key] !== after[key]) return false
  }
  return true
}

export function mergeCanvasFields(
  current: Record<string, unknown> | undefined,
  patch: Record<string, unknown>,
): Record<string, unknown> {
  return { ...(current || {}), ...patch }
}

/** Returns merged fields when changed, otherwise `null` (caller should skip commit). */
export function patchCanvasFieldsIfChanged(
  current: Record<string, unknown> | undefined,
  patch: Record<string, unknown>,
): Record<string, unknown> | null {
  const next = mergeCanvasFields(current, patch)
  return canvasFieldsShallowEqual(current, next) ? null : next
}
